export default {
  dataSetName: 'Lohnkosten',
  dataName: 'Lohnkosten',
  aggregate: ['amount', 'costs'],
  head: [
    {
      label: 'Tätigkeit',
      key: 'product',
      col: 6,
      leftAlign: true,
      highlight: true,
    },
    {
      label: 'Menge H',
      key: 'amount',
      col: 2,
      placeholder: '0,000',
      unit: 'h',
      editable: true,
    },
    {
      label: 'Wert EUR',
      key: 'unitPrice',
      col: 2,
      unit: 'EUR',
    },
    {
      label: 'Kosten EUR',
      key: 'totalPrice',
      col: 2,
      unit: 'EUR',
    },
  ],
}
